import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SideGradient, TopGradient, SideSolid, TopSolid } from '../decorators/decorators';
import styled from '../../styles/styled';
export const Card = ({ animated, shadow = 'small', style, className, children, 'data-testid': testId, decoratorPosition, decoratorColor, variant = 'info', ...rest }) => {
    const side = decoratorPosition === 'side';
    const top = decoratorPosition === 'top';
    const danger = variant === 'danger';
    const info = variant === 'info';
    const success = variant === 'success';
    let decorator;
    switch (true) {
        case side && success:
            decorator = _jsx(SideSolid, { decoratorColor: "greenShamrock" });
            break;
        case top && success:
            decorator = _jsx(TopSolid, { decoratorColor: "greenShamrock" });
            break;
        case side && danger:
            decorator = _jsx(SideSolid, { decoratorColor: "red50" });
            break;
        case top && danger:
            decorator = _jsx(TopSolid, { decoratorColor: "red50" });
            break;
        case top && info:
            decorator = _jsx(TopGradient, { animated: animated, customAnimatedColor: decoratorColor });
            break;
        case side && info:
            decorator = _jsx(SideGradient, { animated: animated });
            break;
        default:
            decorator = undefined;
            break;
    }
    return (_jsxs(CardWrapper, { "data-testid": testId, className: className, style: style, shadow: shadow, decorator: !!decorator, ...rest, children: [decorator, children] }));
};
const CardWrapper = styled.div(({ theme, shadow, decorator }) => ({
    position: 'relative',
    borderRadius: 4,
    padding: decorator ? '40px 32px 48px 56px' : '40px',
    boxShadow: theme.shadow[shadow],
    background: theme.colors.white,
}));
//# sourceMappingURL=card.js.map